<script setup lang="ts">
import { DIMENSION_IDS, topLevelClass } from '@/constants'
import GovResponse from '@/components/home/gov-response.vue'
import ImportingRisk from '@/components/home/importing-risk/index.vue'

const props = defineProps<{
    dimension: DIMENSION_IDS.GOV_RESPONSE | DIMENSION_IDS.IMPORTING_RISK
}>()

/**
 * Component to display.
 */
const component = computed(() => {
    switch (props.dimension) {
        case DIMENSION_IDS.GOV_RESPONSE:
            return GovResponse
        case DIMENSION_IDS.IMPORTING_RISK:
            return ImportingRisk
    }
})

/**
 * Loading state.
 */
const loading = ref(true)

/**
 * Fetch the data for the home page.
 */
async function fetchData() {
    try {
        loading.value = true
        await Promise.all([useCountries().fetch(), useMeta().fetch()])
    } catch (error) {
        //console.error(error)
    } finally {
        loading.value = false
    }
}

void fetchData()
</script>

<template>
    <div :class="topLevelClass" style="height: 100%">
        <UiLoader v-if="loading" />
        <Suspense v-else>
            <component :is="component" class="h-full" />
            <template #fallback>
                <UiLoader />
            </template>
        </Suspense>
    </div>
</template>


<style>
@tailwind base;
@tailwind components;
@tailwind utilities;
</style>